module.exports = __webpack_public_path__ + "static/media/hollow_bar_M3.ded056a6.svg";